import axios from 'axios'
import * as types from '../mutation-types'

// state
export const state = {
  patients: [],
  issues:[],
  site:false,
  sites:[],
  loaded: false,
  pagination: {
    current: 1,
    from: 1,
    per_page: 15,
    to:1,
    site_id:null,
    sort_by: 'code',
    sort_dir: 1,
    issues_loaded:false,
    total_count: 0,
    total_pages: 0,
    filterRowVisible:false,
    hideWithdrawn:false,
    hideNotConsented:false,
  },
}



// actions
export const actions = {

  getPatients({ dispatch, commit, state }, params) {
    state.loaded = false
    params = state.pagination
    return axios.get('/api/patients')
      .then((resp) => {
        dispatch('getPatientsIssues')
        commit(types.GET_PATIENTS, resp.data)
      });
  },
  getPatientsIssues({ commit, state }) {
    state.loaded = false
    return axios.get('/api/patients_issues')
      .then((resp) => {
        commit(types.GET_PATIENTS_ISSUES, resp.data)
      });
  },

}

// mutations
export const mutations = {

  [types.GET_PATIENTS](state, data) {
    state.patients = data.patients
    state.issues = data.issues
    state.site = data.site
    state.sites = data.sites
    state.loaded = true
  },
  [types.GET_PATIENTS_ISSUES](state, data) {
    _.each(state.patients,(p,i)=>{
      var pissues = _.find(data.patients,(dp)=>dp.id==p.id)
      if(pissues&&state.patients[i].id == p.id){ 
        Vue.set(state.patients[i], 'issues', pissues.issues);
      }
    })
    state.pagination.issues_loaded = true
  },
}

// getters
export const getters = {
  loaded: state => state.loaded,
}
